import requestSender from "./base/requestSender";

export default function(axiosInstance){
    return {
        get(payload){
            return requestSender('get', 'setting/get', payload);
        },
        save(payload){
            return requestSender('post', 'setting/save', payload);
        },

    }
}